import React from "react"
import ReactSelect from "react-select"

import "./react-select.scss"

export default function CustomReactSelect(props) {
  return (
    <ReactSelect
      placeholder="-- Seleccionar --"
      classNamePrefix="react-select"
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "none",
          background: "red",
          active: "none",
        },
      })}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        option: (styles, { isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "gray" : styles.backgroundColor,
        }),
        control: styles => ({
          ...styles,
          fontSize: "11.375px",
        }),
      }}
      menuPortalTarget={document.body}
      {...props}
    />
  )
}
